module.exports = __webpack_public_path__ + "static/media/05-01.77e97e71.png";